import React, { useState, useContext }from 'react';
import { IonContent, IonHeader, IonFooter, IonTitle, IonToolbar, IonMenuButton, IonButtons, IonButton, IonItem, IonGrid, IonRow, IonCol, IonInput, IonLabel } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';


import '../../css/layout.css';

import { Auth_Zasava_Context } from '../../../storeState/Auth_Zasava_Context'

import { Tab_Overview } from '../components/Tab_Overview'
import { Tab_MerchantList } from '../components/Tab_GetMerchantList'
import { Tab_UserList } from '../components/Tab_GetUserList'
import { Tab_Admin } from '../components/Tab_AdminView'

import {Zasava_Management} from '../components/Zasava_Management_Services'
import { App_Header } from '../components/App_Header';

import { Helpdesk_Internal } from '../components/Modal_HelpChat_Internal';

 export function HomePage_Admin () {

    let zasava_context = useContext(Auth_Zasava_Context);

    let [acctID, setAccountID ] = useState(zasava_context.acctID);
    let [schema, setSchema ] = useState(zasava_context.schema);
    let [access, setAccessRights ] = useState(zasava_context.accessRights);
    let [sessionID, setSessionID ] = useState(zasava_context.sessionID);
    let [baseURL, setBaseURL ] = useState(zasava_context.baseURL);

    let [overivewView, setOverivewView] = useState(false);
    let [getMerchantListView, setGetMerchantListView] = useState(true);
    let [getUserListView, setGetUserListView] = useState(false);
    let [adminView, setAdminView] = useState(false);

    let [overivewView_color, setOverivewView_color] = useState('clear');
    let [getMerchantListView_color, setGetMerchantListView_color] = useState('outline');
    let [getUserListView_color, setGetUserListView_color] = useState('clear');
    let [adminView_color, setAdminView_color] = useState('clear');

    let [viewZasavaManagementModal, setViewZasavaManagementModal] = useState(false);

    let [viewHelpDeskModal, setViewHelpDeskModal] = useState(false);

    //alert('In Zasava Homepage ADMIN');
    
    function handleOverview() 
    {
        setOverivewView(true);
        setGetMerchantListView(false);
        setGetUserListView(false);
        setAdminView(false);

        setOverivewView_color('outline');
        setGetMerchantListView_color('clear');
        setGetUserListView_color('clear');
        setAdminView_color('clear');

    }

    function handleListView_merchant() 
    {
        setOverivewView(false);
        setGetMerchantListView(true);
        setGetUserListView(false);
        setAdminView(false);

        setOverivewView_color('clear');
        setGetMerchantListView_color('outline');
        setGetUserListView_color('clear');
        setAdminView_color('clear');

    }
    function handleListView_user() 
    {
        setOverivewView(false);
        setGetMerchantListView(false);
        setGetUserListView(true);
        setAdminView(false);

        setOverivewView_color('clear');
        setGetMerchantListView_color('clear');
        setGetUserListView_color('outline');
        setAdminView_color('clear');

    }

    function handleView_admin() 
    {
        setOverivewView(false);
        setGetMerchantListView(false);
        setGetUserListView(false);
        setAdminView(true);

        setOverivewView_color('clear');
        setGetMerchantListView_color('clear');
        setGetUserListView_color('clear');
        setAdminView_color('outline');
    }

    const handleHomepage_ghanaVerified = () => {

        if (baseURL === "https://zasava.com/") {
            window.location.href = "https://ghanaverified.com";
        } 
        else if (baseURL === "https://zasavatest.com/") {
            window.location.href = "https://ghanaverifiedtest.com";
        }
    
    };

    //alert("In HOMEPAGE");
    //alert(zasava_context.accessRights)
    // alert(zasava_context.accessRights[0])

    return (
        <React.Fragment>
            <App_Header></App_Header>

            <IonGrid>
                <IonRow >
                    <IonCol size='4'>
                        <IonButton className= 'small-button-tabs' fill={overivewView_color} onClick={() => handleOverview()}>Overview</IonButton>
                    </IonCol>
                    <IonCol size='4'>
                        <IonButton className= 'small-button-tabs' fill={getMerchantListView_color} onClick={() => handleListView_merchant()}>Merchants</IonButton>
                    </IonCol>
                    <IonCol size='4'>
                        <IonButton className= 'small-button-tabs' fill={getUserListView_color} onClick={() => handleListView_user()} >Users</IonButton>
                    </IonCol>
                </IonRow>
                <IonRow className='small_button'>
                    {(zasava_context.accessRights[0] == 'admin' || zasava_context.accessRights[0] == 'super_z') && <IonCol size='12'>
                        <IonButton className= 'small-button-tabs' fill={adminView_color} onClick={() => handleView_admin()} >Admin</IonButton>
                    </IonCol>}
                </IonRow>
            </IonGrid>
                
            <IonContent className='appContent'>

                {overivewView == true && <Tab_Overview openModal={ overivewView } closeModal={() => setOverivewView(false)}></Tab_Overview>}

                {getMerchantListView == true && <Tab_MerchantList openModal={ getMerchantListView } closeModal={() => setGetMerchantListView(false)}></Tab_MerchantList>}

                {getUserListView == true && <Tab_UserList openModal={ getUserListView } closeModal={() => setGetUserListView(false)}></Tab_UserList>}   

                {adminView == true && <Tab_Admin openModal={ adminView } closeModal={() => setAdminView(false)}></Tab_Admin>}   

                {viewHelpDeskModal == true && <Helpdesk_Internal openModal={viewHelpDeskModal} closeModal={() => setViewHelpDeskModal(false)}></Helpdesk_Internal>}

            </IonContent>

            <IonFooter className='grid_footer'>
                    <IonGrid>
                        <IonRow>
                            <IonCol size='2'>
                                <IonButton className="custom-help-button" fill={'clear'} onClick={() => setViewHelpDeskModal(true)}>H</IonButton>
                            </IonCol>
                            <IonCol size='8'>
                                {(zasava_context.accessRights[0] == 'admin' || zasava_context.accessRights[0] == 'super_z') &&  
                                    <IonButton auto-hide='false' onClick={ () => setViewZasavaManagementModal(true)} >Management</IonButton> 
                                }
                            </IonCol>
                            {(zasava_context.accessRights[0] == 'admin' || zasava_context.accessRights[0] == 'super_z') &&
                            <IonCol className='gh_bottom_links_col_right' size='2'>
                                    <IonButton className='small_button' onClick={() => handleHomepage_ghanaVerified()}>GH-Verified</IonButton>
                            </IonCol>}
                        </IonRow>
                    </IonGrid>
            </IonFooter>

            {viewZasavaManagementModal == true && <Zasava_Management openModal={viewZasavaManagementModal} closeModal={() => setViewZasavaManagementModal(false)}></Zasava_Management>}


        </React.Fragment>

    );
};



export default HomePage_Admin;